import store from "../../store";
import moment from "moment";
import { merge } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";

export default class PresentacionesAYB {
  static typeSearch = "local"; //online || local
  static rules = {
    Requerido: [(value) => !!value || "El campo obligatorio"],
  };
  constructor(data = null) {
    this.Id = data?.Id ? data.Id : null;
    this.nom = data?.nom ? data.nom : "";
    this.cbr = data?.cbr ? data.cbr : "";
    this.cvi = data?.cvi ? data?.cvi : "";
    this.Tenant = data?.Tenant
      ? data.Tenant
      : store.getters.getFirebaseApp.tenant;
    (this.pvd = data?.pvd ? data.pvd : {}),
      (this.prd = data?.prd ? data.prd : "");
    this.rdm = data?.rdm ? data?.rdm : null;
    this.ctu = data?.ctu ? data?.ctu : null;
    this.ctp = data?.ctp ? data?.ctp : null;
  }

  static getPropertyModel() {
    return this;
  }

  static async getPresentacionByProd(id,useUnitario = false) {
    const firestore = store.getters.getFirebaseApp.firestore;
    const data = await firestore.queryBuilder("AMC_Presentaciones", [
      firestore.where("prd", "==", id),
    ]);
    let presentacionesArray = [];
    if(useUnitario){
      presentacionesArray.push({Id:null,nom:"UNITARIO",rdm:1,prd:id})
    }
    if (data.empty) {
      return presentacionesArray;
    } else {
      let doc = data.docs.map((doc) => {
        return { Id: doc.ref.id, ...doc.data() };
      });
     
      doc.forEach((data) => {
        if (!data.Dlat) {
          presentacionesArray.push(data);
        }
      });
      return presentacionesArray;
    }
  }
  static getRules() {
    return this.rules;
  }
}
